import { getCelebrities } from './getCelebrities'
import { getNews } from './getNews'
import { getOurHistory } from './getOurHistory'
import { getOurClinic } from './getOurClinic'
import { getServices } from './getServices'
import { getSpecialists } from './getSpecialists'
import { getSeo } from './getSeo'

export * from './getCelebrities'
export * from './getNews'
export * from './getOurHistory'
export * from './getOurClinic'
export * from './getServices'
export * from './getSpecialists'
export * from './getSeo'

export const homeApi = {
  getCelebrities,
  getNews,
  getOurHistory,
  getOurClinic,
  getServices,
  getSpecialists,
  getSeo,
}
